import React from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'

export const CRMBreadCrumbs: React.FC<React.ComponentProps<typeof Breadcrumbs>> = ({ ...props }) => {
  const { t } = useTranslation()

  return (
    <Breadcrumbs {...props}>
      <Crumb
        data-testid='crumb-crm-notification-schedules'
        key='crumb-crm-notification-schedules'
        path='/crm'
        text={t('Crm.NotificationSchedules.Title')}
      />
      <Crumb
        data-testid='crumb-crm-notification-history'
        key='crumb-crm-notification-history'
        path='/crm/notification-history'
        text={t('Crm.NotificationHistory.Title')}
      />
      <Crumb
        data-testid='crumb-crm-notification-history-view'
        key='crumb-crm-notification-history-view'
        path='/crm/notification-history/:uuid'
        text={t('Email.Title')}
      />
      <Crumb
        data-testid='crumb-crm-template-manager'
        key='crumb-crm-template-manager'
        path='/crm/template-manager'
        text={t('Crm.TemplateManager.Title')}
      />
      <Crumb
        data-testid='crumb-crm-notification-schedules-view'
        key='crumb-crm-notification-schedules-view'
        path='/crm/notification-schedules/:uuid'
        text={params => (params.uuid === 'new' ? t('Crm.NotificationSchedules.New') : t('Crm.NotificationSchedules.Edit'))}
      />
    </Breadcrumbs>
  )
}

export default CRMBreadCrumbs
